import React, { useMemo, useRef } from 'react';
import { UIGameActionButton } from '../../../common/UIGameActionButton/index.ts';
import { UIGameResourceCardsTooltipContent } from '../../../common/UIGameResourceCardsTooltipContent/index.ts';
import { getCardsForPiece } from '@colonist/game-card-types';
import { PieceTypes } from '@colonist/game-base-types';
import { useActionButtonCommonErrors } from '../utils.ts';
import { ROAD_IMAGE_PATH } from '../../../utils/gamePieces.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { usePlayerValidators } from '../../../store/selectors/usePlayerValidators.ts';
import { ActionState } from '@colonist/game-states';
import { useCurrentStateValidator } from '../../../store/selectors/useCurrentStateValidator.ts';
import { HiddenUIElement } from '@colonist/game-beginner-mode';
import clsx from 'clsx';
import styles from '../UIGameActionButtonContainer.module.scss';
import { useMechanicValidatorRoad } from '../../../store/selectors/useMechanicValidatorRoad.ts';
const cardsToBuildRoad = getCardsForPiece(PieceTypes.Road);
export const UIGameActionButtonRoad = ({ className })=>{
    const myColor = useGameStore((state)=>state.myColor);
    const currentStateValidator = useCurrentStateValidator();
    const { getPlayerValidator } = usePlayerValidators();
    const playerValidator = getPlayerValidator(myColor);
    const tooltipRef = useRef(null);
    const { errorHelperText, hasCommonErrors } = useActionButtonCommonErrors();
    const { sendBuildRoad, sendCancelAction, sendClearRoadEdgeHighlight } = useGameStore((state)=>state.gameSendEvent);
    const beginnerActionState = useGameStore((state)=>state.gameBeginnerHint.beginnerActionState);
    const roadValidator = useMechanicValidatorRoad();
    const actionStatus = useMemo(()=>{
        if (!roadValidator) {
            return {
                canTakeAction: false
            };
        }
        const useResources = true;
        const canPlaceRoadActionStatus = roadValidator.canPlayerPlaceRoad(myColor, useResources);
        return canPlaceRoadActionStatus;
    }, [
        roadValidator,
        myColor
    ]);
    const triggerFlickerCardsAnimation = ()=>{
        const notEnoughResources = !playerValidator.hasResourceCardsInHand(cardsToBuildRoad);
        if (notEnoughResources) {
            var _tooltipRef_current;
            (_tooltipRef_current = tooltipRef.current) === null || _tooltipRef_current === void 0 ? void 0 : _tooltipRef_current.triggerFlickerAnimation();
        }
    };
    const isHidden = beginnerActionState === null || beginnerActionState === void 0 ? void 0 : beginnerActionState.hiddenUIElements.includes(HiddenUIElement.RoadActionButton);
    const isSomePlayerSelectingToDiscard = currentStateValidator.isSomePlayerInActionState(ActionState.SelectCardsToDiscard);
    const disabled = hasCommonErrors || !actionStatus.canTakeAction || isHidden || isSomePlayerSelectingToDiscard;
    const helperText = errorHelperText || actionStatus.errorMessageIfCantTakeAction;
    const icon = ROAD_IMAGE_PATH[myColor];
    const actionState = currentStateValidator.getPlayerActionState(myColor);
    const isPlacingRoad = actionState === ActionState.PlaceRoad && !disabled;
    var _roadValidator_getRoadPlayerState_bankRoadAmount;
    const bankRoadAmount = (_roadValidator_getRoadPlayerState_bankRoadAmount = roadValidator === null || roadValidator === void 0 ? void 0 : roadValidator.getRoadPlayerState(myColor).bankRoadAmount) !== null && _roadValidator_getRoadPlayerState_bankRoadAmount !== void 0 ? _roadValidator_getRoadPlayerState_bankRoadAmount : 0;
    const onClick = ()=>{
        if (disabled) return;
        if (isPlacingRoad) {
            sendClearRoadEdgeHighlight();
            sendCancelAction();
        } else {
            sendBuildRoad();
        }
    };
    return /*#__PURE__*/ React.createElement(UIGameActionButton, {
        className: clsx(className, {
            [styles.hidden]: isHidden
        }),
        count: bankRoadAmount,
        countColor: myColor,
        disabled: disabled,
        helperText: helperText,
        highlight: isPlacingRoad,
        iconPath: icon,
        onClickActionIfDisabled: triggerFlickerCardsAnimation,
        tooltipCustomMenuComponent: /*#__PURE__*/ React.createElement(UIGameResourceCardsTooltipContent, {
            cardInventory: playerValidator.resourceCards.cards,
            cardsToBuild: cardsToBuildRoad,
            ref: tooltipRef
        }),
        onClick: onClick
    });
};
